/* PDP behavior: colorway -> gallery swap, live price, availability, cart add.
   Progressive enhancement — the radios and form submit fine without this. */

(function () {
  var root = document.querySelector('[data-wtp-product]');
  if (!root) return;

  var dataEl = root.querySelector('[data-wtp-variants]');
  var variants = [];
  try {
    variants = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }

  var form = root.querySelector('[data-wtp-product-form]');
  var idInput = root.querySelector('[data-wtp-variant-id]');
  var priceEl = root.querySelector('[data-wtp-price]');
  var colorLabel = root.querySelector('[data-wtp-color-label]');
  var mainImg = root.querySelector('.wtp-gallery__main img');
  var addBtn = root.querySelector('[data-wtp-add]');
  var thumbs = root.querySelectorAll('[data-wtp-thumb]');

  function money(cents) {
    return '$' + (Number(cents) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function selected(which) {
    var el = root.querySelector('input[data-wtp-option="' + which + '"]:checked');
    return el ? el.value : null;
  }

  function findVariant() {
    var c = selected('1');
    var s = selected('2');
    return variants.find(function (v) {
      return (c === null || v.option1 === c) && (s === null || v.option2 === s);
    });
  }

  function setMainImage(src, alt) {
    if (!mainImg || !src) return;
    mainImg.src = src;
    if (alt) mainImg.alt = alt;
    thumbs.forEach(function (t) {
      if (t.getAttribute('data-media-src') === src) t.setAttribute('aria-current', 'true');
      else t.removeAttribute('aria-current');
    });
  }

  // Mark size options unavailable for the chosen colorway.
  function refreshSizeAvailability() {
    var c = selected('1');
    root.querySelectorAll('input[data-wtp-option="2"]').forEach(function (input) {
      var match = variants.find(function (v) {
        return v.option1 === c && v.option2 === input.value;
      });
      var ok = !match || match.available;
      input.closest('.wtp-size').classList.toggle('wtp-size--unavailable', !ok);
      input.disabled = !ok;
    });
  }

  function update() {
    var variant = findVariant();
    refreshSizeAvailability();

    if (colorLabel) colorLabel.textContent = selected('1') || '';

    if (!variant) {
      if (addBtn) {
        addBtn.setAttribute('aria-disabled', 'true');
        addBtn.textContent = 'Unavailable';
      }
      return;
    }

    if (idInput) idInput.value = variant.id;
    if (priceEl) priceEl.textContent = money(variant.price);
    if (variant.image) setMainImage(variant.image, colorLabel ? colorLabel.textContent : '');

    if (addBtn) {
      if (variant.available) {
        addBtn.removeAttribute('aria-disabled');
        addBtn.textContent = 'Add to cart';
      } else {
        addBtn.setAttribute('aria-disabled', 'true');
        addBtn.textContent = 'Sold out';
      }
    }

    // Keep the URL shareable without a reload.
    if (window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }
  }

  root.querySelectorAll('input[data-wtp-option]').forEach(function (input) {
    input.addEventListener('change', update);
  });

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      setMainImage(thumb.getAttribute('data-media-src'), thumb.getAttribute('aria-label'));
    });
  });

  // Add to cart via the Cart API so Dawn's drawer can open in place.
  if (form && addBtn) {
    form.addEventListener('submit', function (event) {
      if (event.submitter && event.submitter.name === 'checkout') return; // let Buy it now post
      var drawer = document.querySelector('cart-drawer');
      if (!drawer) return; // no drawer: normal form post to /cart/add
      event.preventDefault();

      addBtn.setAttribute('aria-disabled', 'true');
      var original = addBtn.textContent;
      addBtn.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: 1 }] }),
      })
        .then(function (r) {
          return r.json();
        })
        .then(function () {
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          if (typeof drawer.open === 'function') drawer.open(addBtn);
        })
        .catch(function () {
          form.submit();
        })
        .finally(function () {
          addBtn.removeAttribute('aria-disabled');
          addBtn.textContent = original;
        });
    });
  }

  update();
})();
